import { RestRequest, } from '@Utils';
import {
  IOngoingChannel,
  IPreviewVoiceRecording,
  ISharedVoiceCall,
  ISharedVoiceRecording,
  IPreviewVoiceCall,
  ISharedVoiceCallBridge,
  ChannelEnum,
  ISharedConversation,
  IConversationTimeline,
  IPreviewVoiceCallBridge,
  ICreateExternalBlindTransferRequest,
  ICreateInternalBlindTransferRequest,
} from 'atlas-shared';

export const voiceCallStartRecording = (organization_id: ISharedVoiceCall['organization_id'], voice_call_id: ISharedVoiceCall['id'], voice_call_bridge_id: ISharedVoiceCallBridge['id']): Promise<any> => {
  return RestRequest.post<any, ISharedVoiceRecording>(`voice_recording/${organization_id}/${voice_call_id}/${voice_call_bridge_id}/start_recording`, {});
};

export const voiceCallStopRecording = (organization_id: ISharedVoiceCall['organization_id'], voice_recording_id: IPreviewVoiceRecording['id']): Promise<any> => {
  return RestRequest.put<any, ISharedVoiceRecording>(`voice_recording/${organization_id}/${voice_recording_id}/stop_recording`, {});
};

export const voiceCallsOngoing = (): Promise<Array<IOngoingChannel>> => {
  return RestRequest.get<Array<IOngoingChannel>>('voice_call/ongoing');
};

export const hangupVoiceCall = async (organization_id: ISharedVoiceCall['organization_id'], id: IPreviewVoiceCallBridge['id']): Promise<IPreviewVoiceCall> => {
  return RestRequest.delete<IPreviewVoiceCall>(`voice_call/p/${organization_id}/${id}/terminate`);
};

export const blindTransferVoiceCallExternal = async (organization_id: ISharedVoiceCall['organization_id'], id: IPreviewVoiceCall['id'], voice_call_bridge_id: IPreviewVoiceCallBridge['id'], body: ICreateExternalBlindTransferRequest): Promise<ISharedVoiceCallBridge> => {
  return RestRequest.put<ICreateExternalBlindTransferRequest, ISharedVoiceCallBridge>(`voice_call/p/${organization_id}/${id}/${voice_call_bridge_id}/blind-transfer/external`, body);
};

export const blindTransferVoiceCallInternal = async (organization_id: ISharedVoiceCall['organization_id'], id: IPreviewVoiceCall['id'], voice_call_bridge_id: IPreviewVoiceCallBridge['id'], body: ICreateInternalBlindTransferRequest): Promise<ISharedVoiceCallBridge> => {
  return RestRequest.put<ICreateInternalBlindTransferRequest, ISharedVoiceCallBridge>(`voice_call/p/${organization_id}/${id}/${voice_call_bridge_id}/blind-transfer/internal`, body);
};

export const attendedTransferVoiceCallBridge = async (organization_id: ISharedVoiceCall['organization_id'], bridge_id: IPreviewVoiceCall['id'], transfer_bridge_id: IPreviewVoiceCall['id']): Promise<ISharedVoiceCallBridge> => {
  return RestRequest.put<{}, ISharedVoiceCallBridge>(`voice_call/p/${organization_id}/${bridge_id}/attended-transfer/${transfer_bridge_id}`, {});
};

export const hangupVoiceCallBridge = async (organization_id: ISharedVoiceCall['organization_id'], voice_call_bridge_id: IPreviewVoiceCallBridge['id']): Promise<boolean> => {
  return RestRequest.delete<boolean>(`voice_call/p/${organization_id}/${voice_call_bridge_id}/hangup`);
};

export const holdVoiceCallBridge = async (organization_id: ISharedVoiceCall['organization_id'], voice_call_bridge_id: IPreviewVoiceCallBridge['id']): Promise<boolean> => {
  return RestRequest.put<any, boolean>(`voice_call/p/${organization_id}/${voice_call_bridge_id}/hold`, {});
};

export const unholdVoiceCallBridge = async (organization_id: ISharedVoiceCall['organization_id'], voice_call_bridge_id: IPreviewVoiceCallBridge['id']): Promise<boolean> => {
  return RestRequest.put<any, boolean>(`voice_call/p/${organization_id}/${voice_call_bridge_id}/unhold`, {});
};

export const muteVoiceCallBridge = async (organization_id: ISharedVoiceCall['organization_id'], voice_call_bridge_id: IPreviewVoiceCallBridge['id']): Promise<boolean> => {
  return RestRequest.put<any, boolean>(`voice_call/p/${organization_id}/${voice_call_bridge_id}/mute`, {});
};

export const unmuteVoiceCallBridge = async (organization_id: ISharedVoiceCall['organization_id'], voice_call_bridge_id: IPreviewVoiceCallBridge['id']): Promise<boolean> => {
  return RestRequest.put<any, boolean>(`voice_call/p/${organization_id}/${voice_call_bridge_id}/unmute`, {});
};

export const voiceCallsTimeline = (organization_id: ISharedVoiceCall['organization_id'], conversation_id: ISharedConversation['id'], voice_call_id: ISharedVoiceCall['id']): Promise<{voice_call: IPreviewVoiceCall; events: Array<IConversationTimeline>}> => {
  return RestRequest.get<{voice_call: IPreviewVoiceCall; events: Array<IConversationTimeline>}>(`conversation/p/${organization_id}/${conversation_id}/${ChannelEnum.Voice}/${voice_call_id}/timeline`, {});
};

export const fetchVoiceCalls = async (): Promise<Array<IPreviewVoiceCall>> => {
  return RestRequest.get<Array<IPreviewVoiceCall>>('voice_call', { socket_id: global.socketId, });
};

export { fetchVoiceCall, patchVoiceCall, } from './abstract/voice_call.api.abstract';
